export const NUMBER_OF_HELP_CENTERS_TO_FETCH = 10;
// This is subtracted from th total number of helpcenters to prefetch the next page
export const PREFETCH_OPTIONS = 5;
